import { render, staticRenderFns } from "./addPrefFileDialog.vue?vue&type=template&id=211e011f&scoped=true&"
import script from "./addPrefFileDialog.vue?vue&type=script&lang=tsx&"
export * from "./addPrefFileDialog.vue?vue&type=script&lang=tsx&"
import style0 from "./addPrefFileDialog.vue?vue&type=style&index=0&id=211e011f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "211e011f",
  null
  
)

export default component.exports